<ng-container *ngIf="params && params.value !== undefined && params.value !== null">
	<a
		*ngIf="routerLinkParams !== undefined else notALink"
		[routerLink]="routerLinkParams.commands"
		[fragment]="routerLinkParams.extras?.fragment"
		[preserveFragment]="routerLinkParams.extras?.preserveFragment || false"
		[queryParams]="routerLinkParams.extras?.queryParams"
		[queryParamsHandling]="routerLinkParams.extras?.queryParamsHandling"
		[relativeTo]="routerLinkParams.extras?.relativeTo"
		[replaceUrl]="routerLinkParams.extras?.replaceUrl || false"
		[skipLocationChange]="routerLinkParams.extras?.skipLocationChange || false"
		[state]="routerLinkParams.extras?.state"
		class="copo-datacenter-grid-link">{{ params.value }}</a>
	<ng-template #notALink>
		{{ params.value }}
	</ng-template>
</ng-container>